import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBig = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 80.2", ref, ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "59.7,0.9 49.8,10.9 72,33.1 1.1,33.1 1.1,47.1 72,47.1 49.8,69.3 59.7,79.3 98.9,40.1" }));
const ForwardRef = forwardRef(SvgArrowBig);
export default ForwardRef;
